export default __webpack_public_path__ + "static/media/multiverse.1df5dfea.png";